import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, Observable, of } from 'rxjs';
import { LoginService } from '../services/login.service';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordLoginResolver {
  constructor(
    private loginService: LoginService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.loginService.resetPasswordLogin().pipe(
      map(user => user),
      catchError(error => {
        this.toastr.error('', 'Se ha producido un error');
        this.router.navigate(['/login']);
        return of({ list: null, error: error });
      })
    );
  }
}
